import {
  EDIT_EMAIL_RESEND, REQUEST_RESEND_ACTIVATION, RESET_RESENT_FORM,
  REQUEST_RESEND_ACTIVATION_SUCCESS, REQUEST_RESEND_ACTIVATION_FAILED
} from "../actions/resend_activation_actions";


const initialState = {
  email: '',
  requestProgress: false,
  requestFailed: false,
}

export const resendFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_EMAIL_RESEND: {
      return {
        ...state,
        email: action.email
      }
    }
    case RESET_RESENT_FORM: {
      return {
        ...state,
        email: ''
      }
    }
    case REQUEST_RESEND_ACTIVATION: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false,
      }
    }
    case REQUEST_RESEND_ACTIVATION_SUCCESS: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: false,
      }
    }
    case REQUEST_RESEND_ACTIVATION_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true,
      }
    }
    default: return state;
  }
}
